import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function VerifyPage() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('Invalid link');
      return;
    }

    fetch(`/api/auth/verify?token=${token}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          // Store session token and email
          sessionStorage.setItem('sessionToken', data.sessionToken);
          sessionStorage.setItem('userEmail', data.email);
          navigate('/upload');
        } else {
          setError(data.error || 'Link expired or invalid');
        }
      })
      .catch(() => setError('Connection error'));
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div className="container">
        <h1>Enhanced UIO</h1>
        <div className="error">{error}</div>
        <p className="info" style={{ marginTop: 16 }}>
          <a href="/" style={{ color: '#222' }}>Request a new link</a>
        </p>
        <div className="footer">Internal Tool</div>
      </div>
    );
  }

  return (
    <div className="container">
      <h1>Enhanced UIO</h1>
      <p>Verifying<span className="loading"></span></p>
    </div>
  );
}
